module.exports = __webpack_public_path__ + "static/media/Value-Based Culture Workshop.3a76a791.pdf";